import React, { useContext } from 'react'
import { Formik, Form as FormikForm } from 'formik'

import { CardContent, CardFooter, CardHeading } from '../../../../components/layout/Card'
import { Button } from '../../../../components/Button'
import { RemindersContext } from '../../context'
import {
  InputFieldWithLabel,
  DateFieldWithLabel
} from '../../../../components/Form/Fields'
import { setupValidationSchema, initialReminderFormValues } from './validations'
import { CREATE_FORM } from './formModes'

export const Form = () => {
  const {
    actions: { submitCreateReminderForm, submitUpdateReminderForm },
    state: { mode, reminder }
  } = useContext(RemindersContext)

  return (
    <>
      <CardHeading>
        <h5>{mode === CREATE_FORM ? 'Adding reminder' : 'Editing reminder'}</h5>
      </CardHeading>
      <CardContent className='wealth-manager-reminders__form'>
        <Formik
          initialValues={initialReminderFormValues(reminder)}
          validationSchema={setupValidationSchema}
          validateOnChange
          onSubmit={(values) => { mode === CREATE_FORM ? submitCreateReminderForm(values) : submitUpdateReminderForm(values) }}
        >
          {(formProps) => (
            <FormFields
              formProps={formProps}
            />
          )}
        </Formik>
      </CardContent>
    </>
  )
}

const FormFields = ({ formProps }) => {
  return (
    <FormikForm
      className='app-form'
    >
      <InputFieldWithLabel
        label='What do you want to be reminded about?'
        name='description'
      />
      <DateFieldWithLabel
        label='When is it due?'
        name='due_at'
        values={formProps.values}
        setValues={formProps.setValues}
        errors={formProps.errors}
        touched={formProps.touched}
        setFieldTouched={formProps.setFieldTouched}
      />
      <DateFieldWithLabel
        label='When do you want to be reminded?'
        name='remind_at'
        values={formProps.values}
        setValues={formProps.setValues}
        errors={formProps.errors}
        touched={formProps.touched}
        setFieldTouched={formProps.setFieldTouched}
      />
      <Actions
        formProps={formProps}
      />
    </FormikForm>
  )
}

const Actions = ({ formProps }) => {
  const {
    actions: { cancel },
    state: { mode }
  } = useContext(RemindersContext)
  return (
    <CardFooter className='wealth-manager-reminders__form__actions'>
      <Button
        secondary
        onClick={cancel}
        trackAs='Reminder: Cancel'
      >
        Cancel
      </Button>
      <Button
        primary
        type='submit'
        trackAs={mode === CREATE_FORM ? 'Reminder: Save Reminder' : 'Reminder: Update Reminder'}
        disabled={!formProps.isValid || formProps.isSubmitting}
      >
        {getButtonText(mode, formProps.isSubmitting)}
      </Button>
    </CardFooter>
  )
}

const getButtonText = (mode, isSubmitting) => {
  if (isSubmitting) {
    return getIsSubmittingButtonText(mode)
  } else {
    return getNotSubmittingButtonText(mode)
  }
}

const getIsSubmittingButtonText = (mode) => {
  return mode === CREATE_FORM ? 'Saving...' : 'Updating...'
}

const getNotSubmittingButtonText = (mode) => {
  return mode === CREATE_FORM ? 'Save' : 'Update'
}
